export default __webpack_public_path__ + "static/Entenda0063-b2ea3187ab27d6622e5828e7e0fb6530.jpg";